import { useState, useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";

import FilterModal from "../../filterModal";

import { FiltersContext } from "../../../services/context/filters";

import funnel from "../../../assets/funnel.png";
import lens from "../../../assets/lens.png";

import "./searchStyles.css";

const Search = ({ showPriceFilter, showTimeFilter }) => {
  const { setFilters } = useContext(FiltersContext);
  const [displayFilterModal, setDisplayFilterModal] = useState(false);

  const onChangeSearchInput = (event) => {
    const value = event?.target?.value;
    value.length >= 4 ? setFilters({ name: value }) : setFilters({});
  };

  return (
    <>
      <FilterModal
        displayModal={displayFilterModal}
        setDisplayModal={setDisplayFilterModal}
        showPriceFilter={showPriceFilter}
        showTimeFilter={showTimeFilter}
      />
      <Container className="input-container w-100">
        <Row className="align-items-center">
          <Col xs={10} className="p-0">
            <div className="border-input">
              <div className="background-input px-3 py-1">
                <Row>
                  <Col xs={2}>
                    <img src={lens} alt="lens" />
                  </Col>
                  <Col className="pl-0 pr-3">
                    <input
                      type="text"
                      className="input w-100"
                      placeholder="Search..."
                      onChange={onChangeSearchInput}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col xs={2} className="p-0">
            <button
              className="button-filter"
              onClick={() => setDisplayFilterModal(true)}
            >
              <img src={funnel} alt="filter" />
            </button>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Search;
